<template>
    <div class="home-header">
      <div class="header-container">
        <img src="../assets/hr3logo.png" alt="Логотип" class="logo" />

        <div class="nav-links">
          <button class="nav-button" @click="$emit('about-click')">О нас</button>
          <button class="nav-button" @click="$emit('employers-click')"> Преимущества</button>
          <button class="investor-button" @click="goToInvestors">Для инвесторов</button>
          <button class="nav-button" @click="goToSupport">Поддержка</button>
        </div>
  
        <button
          class="work-button"
          type="button"
          @click="$emit('start-work-click')"
        >
          <span>Войти</span>

          <svg
            class="work-button__icon"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 9H14M10 5L14 9L10 13"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
      </div>
  
    </div>
    <div class="separator"></div>
  </template>
  
  <script setup>

  import { useRouter } from 'vue-router';
  const router = useRouter();

  function goToInvestors() {
    router.push('/for-investors');
  }

  function goToSupport() {
    router.push('/support');
  }

  </script>
  
  <style scoped>

.home-header {
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: var(--bg); 
}
  
.header-container {
  width: 1100px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  height: 100%;
  padding-bottom: 1px; 
}
  
  .logo {
    width: 60px;
    height: 30px;
  }
  
  .nav-links {
    display: flex;
    gap: 32px;
    margin-left: 40px;
  }
  
.nav-button {
  font-family: "Eastman-Medium", sans-serif;
  font-size: 16px;
  color: var(--text);
  background: none;
  border: none;
  cursor: pointer;
  position: relative;
  padding-bottom: 2px;
  transition: color 0.2s;
  letter-spacing: -0.8px;
}

.nav-button::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 0%;
  background-color: #565656;
  transition: width 0.3s ease;
}

.nav-button:hover::after {
  width: 100%;
}
  
.work-button {
  margin-left: auto;
  background-color: #2277E6;
  color: white;
  padding: 10px 24px;
  border-radius: 24px;
  font-family: "Eastman-Medium", sans-serif;
  font-size: 16px;
  border: none;
  cursor: pointer;
  transition: 0.2s;
  letter-spacing: -1.0px;
}

.work-button:hover {
  opacity: 0.85;
}
  
.separator {
  width: 100%;
  height: 1px;
  background-color: var(--separator_home);
  flex-shrink: 0;
  z-index: 10;
  position: relative;
}

[data-theme="light"] {
  --separator: #E3E3E3;
}

[data-theme="dark"] {
  --separator: #373737;
}

.investor-button {
  font-family: "Eastman-Medium", sans-serif;
  font-size: 14px;
  background-color: #eaf2ff;
  background-color: var(--investor-bg);
  color: #2277E6;
  border: none;
  padding: 10px 22px;
  border-radius: 999px;
  cursor: pointer;
  transition: 0.2s ease;
  letter-spacing: -0.8px;
}

.investor-button:hover {
  background-color: #dceaff;
}

@media (max-width: 768px) {

.home-header {
  height: auto;
  padding: 12px 0;
}

.header-container {
  width: 100%;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.nav-links {
  display: none;
}

.logo {
  width: 48px;
  height: auto;
}

.work-button {
  padding: 8px 18px;
  font-size: 14px;
  border-radius: 20px;
  margin-right: 40px;
}

.separator {
  margin-top: 8px;
}
}

.nav-button {
  font-family: "Eastman-Medium", sans-serif;
  font-size: 16px;
  color: var(--text);

  background: none;
  border: none;

  cursor: pointer;
  position: relative;

  padding: 10px 2px;

  letter-spacing: -0.8px;

  transition:
    color 0.2s ease,
    transform 0.2s ease;
}

.nav-button::after {
  content: "";

  position: absolute;
  left: 50%;
  bottom: 4px;

  width: 0;
  height: 2px;

  border-radius: 999px;

  background-color: #2277e6;

  transform: translateX(-50%);

  transition:
    width 0.25s ease;
}

.nav-button:hover {
  color: #2277e6;
  transform: translateY(-1px);
}

.nav-button:hover::after {
  width: 100%;
}

.nav-button:active {
  transform: scale(0.97);
}

.investor-button {
  font-family: "Eastman-Medium", sans-serif;
  font-size: 14px;

  color: #2277e6;

  background:
    linear-gradient(
      135deg,
      color-mix(in srgb, #2277e6 10%, transparent),
      color-mix(in srgb, #2277e6 6%, transparent)
    );

  border: 1px solid
    color-mix(
      in srgb,
      #2277e6 14%,
      transparent
    );

  padding: 10px 22px;
  border-radius: 999px;

  cursor: pointer;

  letter-spacing: -0.8px;

  box-shadow:
    0 6px 18px rgba(34, 119, 230, 0.08);

  transition:
    transform 0.2s ease,
    background-color 0.2s ease,
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.investor-button:hover {
  transform: translateY(-2px);

  background:
    linear-gradient(
      135deg,
      color-mix(in srgb, #2277e6 15%, transparent),
      color-mix(in srgb, #2277e6 9%, transparent)
    );

  border-color:
    color-mix(
      in srgb,
      #2277e6 24%,
      transparent
    );

  box-shadow:
    0 10px 24px rgba(34, 119, 230, 0.14);
}

.investor-button:active {
  transform: scale(0.97);
}

.work-button {
  position: relative;
  overflow: hidden;

  margin-left: auto;

  min-height: 48px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;

  padding: 0 23px;

  color: white;

  font-family: "Eastman-Medium", sans-serif;
  font-size: 16px;
  letter-spacing: -1px;

  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 999px;

  background:
    linear-gradient(
      135deg,
      #3b8df5 0%,
      #2277e6 58%,
      #1764d2 100%
    );

  box-shadow:
    0 10px 26px rgba(34, 119, 230, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.22);

  cursor: pointer;

  transition:
    transform 0.2s ease,
    box-shadow 0.2s ease;
}

.work-button::before {
  content: "";

  position: absolute;

  top: -80%;
  left: -60%;

  width: 45%;
  height: 260%;

  background:
    linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.32),
      transparent
    );

  transform: rotate(18deg);

  transition:
    left 0.7s ease;
}

.work-button:hover {
  transform: translateY(-2px);

  box-shadow:
    0 14px 32px rgba(34, 119, 230, 0.32),
    inset 0 1px 0 rgba(255, 255, 255, 0.24);
}

.work-button:hover::before {
  left: 120%;
}

.work-button:active {
  transform: scale(0.97);
}

.work-button__icon {
  transition:
    transform 0.2s ease;
}

.work-button:hover .work-button__icon {
  transform: translateX(3px);
}

  </style>